import { cn } from "@/lib/utils";
import { Input } from "@altimateai/lego";
import { ComponentProps } from "react";

interface FormInputProps extends ComponentProps<typeof Input> {
  isInvalid?: boolean;
}

const FormInput = ({ className, isInvalid = false, ...props }: FormInputProps) => {
  const baseStyles =
    "al-border al-bg-gray-10 al-text-dark placeholder:al-text-gray-40 al-text-xs disabled:al-bg-gray-10";
  const borderStyles = isInvalid ? "!al-border-action-red" : "!al-border-gray-40";
  const shapeStyles = isInvalid ? "al-rounded-t-xl al-rounded-b-none" : "al-rounded-xl";
  const focusStyles = "focus:!al-border-primary focus-visible:!al-ring-transparent";
  const autofillStyles = isInvalid
    ? "[&:-webkit-autofill]:!al-border-action-red [&:-webkit-autofill]:focus:!al-border-primary [&:-webkit-autofill]:al-text-dark"
    : "[&:-webkit-autofill]:!al-border-gray-40 [&:-webkit-autofill]:focus:!al-border-primary [&:-webkit-autofill]:al-text-dark";

  return (
    <Input
      className={cn(baseStyles, borderStyles, shapeStyles, focusStyles, autofillStyles, className)}
      {...props}
    />
  );
};

export default FormInput;
